import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {DraftJobChanges} from "../../../models/draft-job-changes.model";
import {DraftJobChangeField} from "../../../types/draft-job-change-field.enum";

require('./planning-draft-job-change-diff.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-job-change-diff',
  templateUrl: './planning-draft-job-change-diff.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobChangeDiffComponent {
  @Input() change: DraftJobChanges;

  public readonly fields = DraftJobChangeField;

  isBlocked(field: DraftJobChangeField): boolean {
    return !!this.change?.changed?.blockedFields?.includes(field);
  }
}
